import {TimelineMax, Cubic} from 'gsap'
import morphSVG from '../vendor/MorphSVGPlugin'
import _ from 'lodash'

export default () => {
  return {
    template: '#splash',
    data: () => ({
      id: 'Decor0',
      timeline: null,
      settings: {
        speed: 1, // length of time it takes to complete a cycle
        ease: Cubic.easeInOut, // ease style //https://greensock.com/docs/Easing
        delay: 1 // timing between animations
      }
    }),
    mounted () {
      this.$store.dispatch('decor/create', {})
      .then((which) => {
        // returns the 'id' of the newly created panel item
        this.element = this.$el
        this.svg = this.$refs.svg
        this.id = which
        this.buildSVG()
      })
      .then(() => {
        this.playSVG()
      })
    },
    watch: {
    },
    computed: {
    },
    methods: {
      getId (base, prefix) {
        base = (_.isString(base)) ? '-' + base : ''
        prefix = (_.isString(prefix)) ? prefix : ''
        return prefix + this.id + base
      },
      playSVG () {
        this.timeline.play()
      },
      buildSVG () {
        const settings = this.settings
        const square = this.$refs.square
        const bubble = this.$refs.bubble

        this.timeline = new TimelineMax({ paused: true, onComplete: this.onComplete })

        this.timeline.startTime(0)
        let center = this.getCenter(square, -20)
        this.timeline
          .set('.splash__text', { attr: { opacity: 1 } })
          .set(square, {position: 'absolute', left: 0, top: 0, transformOrigin: 'center center'})
          .to('.splash__text', settings.speed, { attr: { opacity: 0 }, ease: settings.ease }, settings.speed * 1)
          .to(square, settings.speed * 2,
          {
            top: '50%',
            left: '50%',
            xPercent: '-50',
            yPercent: '-50',
            scale: 20,
            x: center.x,
            y: center.y,
            ease: settings.ease
          }, settings.speed * 2)
        .to(square, settings.speed * 3,
          {
            ease: settings.ease,
            morphSVG: { shape: bubble }
          }, settings.speed * 1.75)
      },
      onComplete () {
        const timer = setTimeout(() => {
          this.$store.dispatch('splash/end')
          clearTimeout(timer)
        }, 150)
      },
      getCenter (el, offsetX, offsetY) {
        offsetX = _.isNumber(offsetX) ? offsetX : 0
        offsetY = _.isNumber(offsetY) ? offsetY : 0
        let bbox = el.getBBox()
        const svg = this.$refs.svg
        let viewBox = svg.getAttribute('viewBox')
        viewBox = viewBox.split(' ')
        let cx = parseFloat(viewBox[0]) + (parseFloat(viewBox[2]) / 2)
        let cy = parseFloat(viewBox[1]) + (parseFloat(viewBox[3]) / 2)
        let x = cx - bbox.x - ((bbox.width / 2) + offsetX)
        let y = cy - bbox.y - ((bbox.height / 2) + offsetY)
        return { x: x, y: y }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/splash.js